import Component from '@cell/cell-core/component/component';
import './dropdown-content.scss';

class DropdownContent extends Component {
  constructor() {
    super();

    this.active = this.getAttribute('aria-hidden') === 'false';

    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOnWindow = this.handleClickOnWindow.bind(this);
  }

  componentDidMount() {
    globalThis.on('dropdown-trigger.toggle', this.handleToggle);
  }

  handleToggle({ data }) {
    // Ignore if the handle doesn't match the handle of this dropdown content.
    if (data.handle !== this.parsedDataset.handle) return;

    if (this.active) {
      this.close();
    } else {
      this.open();
    }
  }

  handleClickOnWindow({ target }) {
    // Ignore click if it was on the trigger element.

    const connectedTriggerElement = document.querySelector(
      `dropdown-trigger[data-handle="${this.parsedDataset.handle}"]`,
    );

    if (connectedTriggerElement && connectedTriggerElement.contains(target)) {
      return;
    }

    // Ignore click if it was on any children of the dropdown content.
    if (this.contains(target)) {
      return;
    }

    // Ignore click if it was on the remove filter button. Note: This is a temporary solution and
    // should actually not be handled here.
    if (target.closest('[data-action="remove-filter"]')) {
      return;
    }

    this.close();
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    this.classList.remove('DropdownContent--Active');

    this.active = false;

    this.removeCloseEventListener();

    // Notify other components that the dropdown content has been closed.
    this.emit('closed', {
      handle: this.parsedDataset.handle,
    });
  }

  open() {
    this.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(() => {
      this.classList.add('DropdownContent--Active');
    });

    this.active = true;

    this.setCloseEventListener();

    // Notify other components that the dropdown content has been opened.
    this.emit('opened', {
      handle: this.parsedDataset.handle,
    });
  }

  setCloseEventListener() {
    globalThis.addEventListener('click', this.handleClickOnWindow);
  }

  removeCloseEventListener() {
    globalThis.removeEventListener('click', this.handleClickOnWindow);
  }
}

customElements.define('dropdown-content', DropdownContent);
